import React from "react"

import "./styles.scss"

export default function NavItem({
    icon,
    text,
    secondaryText,
    onClick,
    isOpen = false,
    isBlocked
}) {
    return (
        <>
            <div className="nav_item" onClick={onClick}>
                <div
                    className="nav_item_main"
                    data-is-open={isOpen}
                    data-is-blocked={isBlocked}
                >
                    <div className="nav_main_text">
                        <p className="title-item hydrated">{text}</p>
                        {secondaryText && <p className="subtitle-item hydrated">{secondaryText}</p>}
                    </div>
                    <div className="nav_main_content">
                        <slot className="header-content"></slot>
                    </div>
                </div>
            </div>

            {/* <bds-nav-tree
                icon={icon}
                text={text}
                secondary-text={secondaryText}
                onClick={onClick}
            >
                <bds-nav-tree-item icon="heart" text="Título"></bds-nav-tree-item> 
            </bds-nav-tree> */}
        </>
    )

    return (
        <div>
            <bds-nav-tree
                icon={icon}
                text={text}
                secondary-text={secondaryText}
                onClick={onClick}
            >
                {/* <bds-nav-tree-item icon="heart" text="Título"></bds-nav-tree-item> */}
            </bds-nav-tree>
        </div>
    )
}